module.exports = __webpack_public_path__ + "img/3422fc53-64b0-4145-be99-696e34c72327.9558a360.svg";